import { render, staticRenderFns } from "./ExitRegisterData.vue?vue&type=template&id=5a5025c3"
import script from "./ExitRegisterData.vue?vue&type=script&lang=js"
export * from "./ExitRegisterData.vue?vue&type=script&lang=js"
import style0 from "./ExitRegisterData.vue?vue&type=style&index=0&id=5a5025c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports